module.exports = __webpack_public_path__ + "assets/filter-new-962b96.svg";